import Dates from 'components/Dates';
import { CompetencyModuleJobFamilyDataArray } from 'types/dacum/moduleManagement';

export const column = [
  {
    heading: 'ID',
    props: 'trCompetencyModuleJobFamilyID',
    sortable: true,
    active: true,
    disabled: false,
    id: 'trCompetencyModuleJobFamilyID'
  },
  {
    heading: 'Job Family ID',
    props: 'jobFamilyID',
    sortable: true,
    active: true,
    disabled: false,
    id: 'jobFamilyID'
  },
  {
    heading: 'Job Family',
    props: 'jobFamilyName',
    sortable: true,
    active: true,
    disabled: false,
    id: 'jobFamilyName'
  },
  {
    heading: 'Date',
    props: ({ dateIn }: CompetencyModuleJobFamilyDataArray) => <Dates date={dateIn} />,
    sortable: true,
    active: true,
    disabled: false,
    id: 'dateIn'
  },
  {
    heading: 'Action',
    props: 'action',
    active: true,
    id: 'action'
  }
];
